import { IKnmIndex } from 'APIPackage/KnmModule/interfaces/IKnmIndex';
import { formatDateLocale } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { mapDataItemToRaw } from 'KnmListPackage/MainModule/common/mapRawToData';
import { IKnmRaw } from 'KnmListPackage/MainModule/interfaces/IKnmRaw';

const numberToWorkDaysPhrase = (days: number) => {
  return `${days} ${getNumEnding(days, ['рабочий день', 'рабочих дня', 'рабочих дней'])}`;
};

const numberToHoursPhrase = (hours: number) => {
  return `${hours} ${getNumEnding(hours, ['час', 'часа', 'часов'])}`;
};

const getNumEnding = (num: number, endings: string[]) => {
  const lastTwoNumbers = num % 100;

  if (lastTwoNumbers >= 11 && lastTwoNumbers <= 19) return endings[2];
  const lastNumber = num % 10;

  switch (lastNumber) {
    case 1:
      return endings[0];
    case 2:
    case 3:
    case 4:
      return endings[1];
    default:
      return endings[2];
  }
};

const renderDuration = (durationDays: number, durationHours: number, directDurationDays: number) => {
  let message = '';

  if (durationDays) {
    message = numberToWorkDaysPhrase(durationDays);
    if (durationHours || directDurationDays) message = `${message} \\`;
  }

  if (durationHours) message = `${message} ${numberToHoursPhrase(durationHours)}`;
  else if (directDurationDays) message = `${message} ${numberToWorkDaysPhrase(directDurationDays)}`;

  return message.trim();
};

export const mapRawToKnmListByPlanData = (data: IKnmIndex[], isErknm: boolean): IKnmRaw[] => {
  return data.map(row => ({
    ...mapDataItemToRaw(row, isErknm),
    startDate: formatDateLocale({ date: row.startDate, dateFormat: DATE_FORMAT_LONG_FNS }),
    durationDays: renderDuration(row.durationDays, row.durationHours, row.directDurationDays),
  }));
};
